import { Component } from '@angular/core';
import { DialogBaseViewComponent, ProgressDialogData } from '@sb/library/base';

@Component({
    selector: 'lib-dialog-progress',
    templateUrl: './dialog-progress.component.html'
})
export class DialogProgressComponent extends DialogBaseViewComponent<ProgressDialogData> {
    override readonly dismissPrevious: boolean = false;

    private _percentageComplete: number = 0;
    private _canCancel = true;

    constructor() {
        super();
        this.data.ProgressObservable?.subscribe({
            next: percentageComplete => {
                this._percentageComplete = percentageComplete;
            },
            complete: () => {
                this._canCancel = false;
            }
        });
    }

    override PrimaryAction() {
        super.PrimaryAction();
        this.DismissAction();
    }

    get percentageComplete(): number {
        return this._percentageComplete;
    }

    get canCancel(): boolean {
        return this._canCancel;
    }
}
